import { JiraIconUrl } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";

import { JiraTrackerComponents } from "./components.ts";

/** The tracker's registration. A tracker isn't a resource or directory
 * integration, so it isn't added to `integrationRegistry`: its catalog card is
 * in the frontend's tracker list, as the AWS Lambda notifier's is in the
 * notifier list. */
export const JiraTrackerRegistration = Registration({
  category: "other",
  components: JiraTrackerComponents,
  // A path here becomes a link in the product, so there's none until the
  // docs page exists.
  docs: {},
  // The new item's form asks for the "Site host".
  identifier: "host",
  itemKind: "Site",
  label: "Jira",
  logoUrl: JiraIconUrl,
  maturity: "preview",
});
